import { render } from "./EditComposition.vue?vue&type=template&id=599fe60a&scoped=true&ts=true"
import script from "./EditComposition.vue?vue&type=script&lang=ts"
export * from "./EditComposition.vue?vue&type=script&lang=ts"

import "./EditComposition.vue?vue&type=style&index=0&id=599fe60a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599fe60a"]])

export default __exports__